import { Routes } from '@angular/router';
import { ContactUsComponent } from './main/components/contact-us/contact-us.component';
import { HomeComponent } from './main/components/home/home.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { UserRoles } from './shared/constants/userRoles/user-roles';
import { authGuardCanMatch } from './shared/route-guards/auth-guard/auth-guard';
import { AgentTripRequestComponent } from './trip-request/agent-view/agent-trip-request/agent-trip-request.component';
import { TripRequestTypeComponent } from './trip-request/trip-request-type/trip-request-type.component';
import { TripRequestWrapperComponent } from './trip-request/trip-request-wrapper/trip-request-wrapper.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Home' },
  { path: 'home', redirectTo: '', title: 'Home', pathMatch: 'full' },
  { path: 'contact-us', component: ContactUsComponent, title: 'Contact Us', pathMatch: 'full' },
  { path: 'trip', component: TripRequestTypeComponent, title: 'Trip Type', pathMatch: 'full' },
  { path: 'trip-request/:tripType', component: TripRequestWrapperComponent, title: 'Trip Request', pathMatch: 'full',
     canMatch: [authGuardCanMatch],
     data: { roles: [UserRoles.Citizen] },
  },
  { path: 'agent-trip-request', component: AgentTripRequestComponent, title: 'Trip Request', pathMatch: 'full', 
    canMatch: [authGuardCanMatch],
    data: { roles: [UserRoles.CountyAdmin, UserRoles.CountyStaff] }, 
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
  },
  { path: '**', component: NotFoundComponent },
];
